import { defineMessages } from 'react-intl';

export default defineMessages({
  emailLabel: {
    id: 'ResetPasswordForm.emailLabel',
    description: 'Login Form email field label',
    defaultMessage: 'Email',
  },
  resetPasswordButton: {
    id: 'ResetPasswordForm.resetPasswordButton',
    description: 'Reset Password Form button text',
    defaultMessage: 'Reset Password',
  },
  emailFormatError: {
    id: 'ResetPasswordForm.emailFormatError',
    description: 'Login Form invalid email address format error message',
    defaultMessage: 'Enter valid email address.',
  },
  emptyEmailError: {
    id: 'ResetPasswordForm.emptyEmailError',
    description: 'Login Form empty email error message',
    defaultMessage: 'Enter valid email address. Field cannot be blank.',
  },
  verificationCodeResetLimitExceeded: {
    id: 'ResetPasswordForm.verificationCodeResetLimitExceeded',
    description: 'Verification code reset Maximum time limit exceeded',
    defaultMessage: 'Maximum time limit exceeded. Please try again later.',
  },
  verificationCodeMismatchException: {
    id: 'ResetPasswordForm.verificationCodeMismatchException',
    description: 'Code is incorrect. Please try again.',
    defaultMessage: 'Code is incorrect. Please try again.',
  },

  verificationCodeExpiredCodeException: {
    id: 'ResetPasswordForm.verificationCodeExpiredCodeException',
    description: 'Verification code is expired.',
    defaultMessage: 'Verification code is expired.',
  },
});
